export const VERSION_INFO = {
  version: '1.38',
  buildDate: '2026-03-22',
  description: 'KI会計システム Web版 (クラシックUI)',
  copyright: '© 2025 KI会計システム'
};
